export default __webpack_public_path__ + "static/media/2014.a5f96325.png";